import {HttpErrorResponse} from '@angular/common/http';
import {Component, OnInit} from '@angular/core';

import {ApisService} from '../apis.service';
import {Applications} from '../applications';
import {ApplicationItem} from '../application-item';
import {MessageService} from '../../core/message/message.service';
import {Subscriptions} from '../subscriptions';
import {SubscriptionItem} from '../subscription-item';

@Component({
  selector: 'aqx-subscriptions',
  templateUrl: './subscriptions.component.html',
  styleUrls: ['./subscriptions.component.scss']
})
export class SubscriptionsComponent implements OnInit {
  allSubscriptions: object[] = [];
  fetching = false;
  fetchingComplete = false;

  private applications: Applications;
  private counterFetchingApplication: number;

  constructor(
    private apisService: ApisService,
    private messageService: MessageService,
  ) {
  }

  ngOnInit() {
    this.getApplications();
  }

  private getApplications() {
    this.fetching = true;
    this.apisService.getApplications()
      .subscribe(
        (applications: Applications) => {
          this.applications = applications;
          if (applications.list.length > 0) {
            this.getSubscriptionsForApplications(applications);
          } else {
            this.fetching = false;
            this.fetchingComplete = true;
          }

        },
        (httpErrorResponse: HttpErrorResponse) => {
          this.fetching = false;
          this.messageService.error(`Error getting applications. ${httpErrorResponse.statusText}.`);
        },
        () => {
        });
  }

  private getSubscriptionsForApplication(application: ApplicationItem) {
    this.apisService.getSubscriptionsForApplication(application.applicationId)
      .subscribe(
        (subscriptions: Subscriptions) => {
          subscriptions.list.forEach((subscription) => {
            // const entry = {applicationId, subscription};
            const enhancedSubscription: any = subscription;
            enhancedSubscription.application = application;
            enhancedSubscription.apiDisplayName = this.apisService.getDisplayNameFromApiIdentifier(enhancedSubscription.apiIdentifier);
            this.allSubscriptions.push(enhancedSubscription);
          });
          if (++this.counterFetchingApplication === this.applications.list.length) {
            this.fetching = false;
            this.fetchingComplete = true;
            this.sortSubscriptions(this.allSubscriptions);
          }
        },
        error => {
          if (++this.counterFetchingApplication === this.applications.list.length) {
            this.fetching = false;
            this.fetchingComplete = true;
          }
          console.log(error);
        },
        () => {
        });
  }

  private getSubscriptionsForApplications(applications) {
    this.counterFetchingApplication = 0;
    applications.list.forEach((application) => {
      this.getSubscriptionsForApplication(application);
    });
  }

  private sortSubscriptions(allSubscriptions) {
    allSubscriptions.sort((a: any, b: any) => {
      return a.apiDisplayName.localeCompare(b.apiDisplayName);
    });
  }

}
